import CookieDeclaration from "views/utils/CookieDeclaration"

function CookieDeclarationPage() {
  return <CookieDeclaration />
}

export async function getStaticProps() {
  return {
    props: {},
  }
}

export default CookieDeclarationPage
